module.exports = __webpack_public_path__ + "img/1746605039_Yahv.02523266.jpg";